'use strict';

var base = require('./base');

/**
 * @description returns text to display
 * @param {string} text - full text
 * @param {number} maxWords - maximum number of words
 * @returns {string} text to display
 */
function getMainInfoText(text, maxWords) {
	return text.split(' ').splice(0, maxWords).join(' ');
}

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
	$('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

module.exports = {
	methods: {
		updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
	},

	availability: base.availability,

	addToCart: base.addToCart,

	updateAttributesAndDetails: function () {
		$('body').on('product:statusUpdate', function (e, data) {

		});
	},

	showSpinner: function () {
		$('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
			$.spinner().start();
		});
	},
	updateAttribute: function () {
		$('body').on('product:afterAttributeSelect', function (e, response) {
			if ($('.product-detail>.bundle-items').length) {
				response.container.data('pid', response.data.product.id);
				response.container.find('.product-id').text(response.data.product.id);
			} else if ($('.product-set-detail').eq(0)) {
				response.container.data('pid', response.data.product.id);
				response.container.find('.product-id').text(response.data.product.id);
			} else {
				$('.product-id').text(response.data.product.id);
				$('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
			}
		});
	},
	updateAddToCart: function () {
		$('body').on('product:updateAddToCart', function (e, response) {
			// update local add to cart (for sets)
			$('button.add-to-cart', response.$productContainer).attr(
				'disabled',
				(!response.product.readyToOrder || !response.product.available)
			);

			var enable = $('.product-availability').toArray().every(function (item) {
				return $(item).data('available') && $(item).data('ready-to-order');
			});
			module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
		});
	},
	updateAvailability: function () {
		$('body').on('product:updateAvailability', function (e, response) {
			var hasErrors = !response.product.available;

			$('div.availability', response.$productContainer)
				.data('ready-to-order', response.product.readyToOrder)
				.data('available', response.product.available)
				.data('delivery-available', response.product.deliveryAvailable);

			$('.availability-msg', response.$productContainer)
				.toggleClass('text-danger', hasErrors)
				.toggleClass('text-success', !hasErrors)
				.empty()
				.html(response.message);

			if ($('.global-availability').length) {
				var allAvailable = $('.product-availability').toArray()
					.every(function (item) { return $(item).data('available'); });

				var allReady = $('.product-availability').toArray()
					.every(function (item) { return $(item).data('ready-to-order'); });

				var allHasDelivery = $('.product-availability').toArray()
					.every(function (item) {
						return $(item).data('delivery-available');
					});

				$('.global-availability')
					.data('ready-to-order', allReady)
					.data('available', allAvailable)
					.data('delivery-available', allHasDelivery);

				$('.global-availability .availability-msg').empty()
					.html(allReady ? response.message : response.resources.info_selectforstock);
			}
		});
	},
	sizeChart: function () {
		$('.size-chart a').on('click', function (e) {
			e.preventDefault();
			var url = $(this).attr('href');
			var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
			if ($prodSizeChart.is(':empty')) {
				$.ajax({
					url: url,
					type: 'get',
					dataType: 'json',
					success: function (data) {
						$prodSizeChart.append(data.content);
					}
				});
			}
			$prodSizeChart.toggleClass('active');
		});

		var $sizeChart = $('.size-chart-collapsible');
		$('body').on('click touchstart', function (e) {
			if ($('.size-chart').has(e.target).length <= 0) {
				$sizeChart.removeClass('active');
			}
		});
	},
	copyProductLink: function () {
		$('body').on('click', '#fa-link', function () {
			// eslint-disable-next-line no-restricted-globals
			event.preventDefault();
			var $temp = $('<input>');
			$('body').append($temp);
			$temp.val($('#shareUrl').val()).select();
			document.execCommand('copy');
			$temp.remove();
			$('.copy-link-message').attr('role', 'alert');
			$('.copy-link-message').removeClass('d-none');
			setTimeout(function () {
				$('.copy-link-message').addClass('d-none');
			}, 3000);
		});
	},
	showProductSetItemDescription: function () {
		$('.set-item:not(.active)').hide();
		$('body').on('click', '.set-image-item', function () {
			$('.set-item').hide();
			let productId = $(this).data('pid');
			let selector = '#' + productId;
			$(selector).show();
		});
	},

	scrollToTop: function () {
		$('.body').on('click', '.set-scroll-top-button', function () {
			$(window).scrollTo(0, 0);
		});
	},
	updateInfoText: function () {
		const metaAttrBlock = $('#meta2txt');
		const DISPLAY_WORDS_COUNT = 80;

		if (metaAttrBlock) {
			let metaText = metaAttrBlock.text();
			const wordCount = metaText.split(' ').length;

			if (wordCount > DISPLAY_WORDS_COUNT) {
				metaText = getMainInfoText(metaText, DISPLAY_WORDS_COUNT);

				const wordArray = metaText.split(' ');
				const lastWord = wordArray[wordArray.length - 1];

				if (/[.,:;?!]/.test(lastWord)) {
					wordArray.pop();
					metaText = wordArray.join(' ');
				}

				metaText += ' <a id="readMore" href="#">...mehr lessen</a>';

				metaAttrBlock.html(metaText);
			}
		}
	},
	metaTextReadMore: function () {
		$('body').on('click', '#readMore', function (e) {
			e.preventDefault();
			const metaAttrBlock = $('#meta2txt');

			metaAttrBlock.html(metaAttrBlock.data('full-attr-text'));
		});
	},
	focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
	shippingTypeChange: base.shippingTypeChange,
	shippingTypeChangeOnProductPage: base.shippingTypeChangeOnProductPage,
	handleProductStores: base.handleProductStores,
	updateShippingDetailsOnVariationChange: base.updateShippingDetailsOnVariationChange
};
